/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
// 以下追記

// スムーススクロール
$(function () {

});

// FAQモバイル用
$(function () {
  $('#list_sp').on('click', function() {
    $('.incoco-faq-link__wrap').toggleClass('open');
    if ($(this).text() == 'リストを開く') {
      $(this).text('リストを閉じる');
    } else {
      $(this).text('リストを開く');
    }
  })
});

// FAQトグル
$(function () {
  $('.incoco-faq__question').click(function () {
    $(this).toggleClass('open');
    $(this).next('.incoco-faq__answer').slideToggle();
  });
});

// アカウントページ
// FAQトグル
$(function () {
  $('#history').click(function () {
    if($(this).hasClass('current')) {
      return
    } else {
      $(this).addClass('current');
      $('#point').removeClass('current');
      $('#history-content').addClass('open');
      $('#point-content').removeClass('open');
    }
  });
  $('#point').click(function () {
    if($(this).hasClass('current')) {
      return
    } else {
      $(this).addClass('current');
      $('#history').removeClass('current');
      $('#point-content').addClass('open');
      $('#history-content').removeClass('open');
    }
  });
});

// FAQ位置
{

  const boxes = document.querySelectorAll(".scroll-point");

  const options = {
    root: null,
    rootMargin: "-50% 0px",
    threshold: 0,
  };
  const observer = new IntersectionObserver(doWhenIntersect, options);
  boxes.forEach((box) => {
    observer.observe(box);
  });

  /**
   * 交差したときに呼び出す関数
   * @param entries
   */
  function doWhenIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        activateIndex(entry.target);
      }
    });
  }
}

/**
 * 目次の色を変える関数
 * @param element
 */
function activateIndex(element) {
  const currentActiveIndex = document.querySelector(
    ".incoco-faq__ul .current"
  );
  console.log(element.id);
  if (currentActiveIndex !== null) {
    currentActiveIndex.classList.remove("current");
  }
  const newActiveIndex = document.querySelector(`a[href='#${element.id}']`);
  newActiveIndex.classList.add("current");
}

// Ytopo登録ボタン用
function newsletter_modal_open(){
  $('.swell-tab').trigger("click");
}
$(function(){
  $('#swell-popup').on('load', function(){
      $('#swell-popup').contents().find('button').css('background','pink');
  });
});

// フィルターアプリの日本語化
$(function () {
  function letterChange() {
    $('.boost-pfs-filter-tree-desktop-button-label').text('フィルター');
    const test = $('.boost-pfs-filter-top-sorting-wrapper span').text();
    const letterGetter = test.includes('Sort By');
    if(letterGetter == true ) {
      $('.boost-pfs-filter-top-sorting-wrapper span').text('並び替え');
    }
  }

  setTimeout(letterChange, 500);
});

//////////////////////////
// スティッキーカート用 //
//////////////////////////
$(function () {
  let items = [];
  let number = 0;

  $('.incoco-sticky-cart__btn').on('click', function () {
    this_id = $(this).data('id');
    number = $('.incoco-sticky-cart__quantity').val();
    let item = { quantity: number, id: this_id };
    items.push(item);
    addCart();

  })

  function addCart() {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items },
      dataType: 'json',
      success: function () {
        console.log("add.js 読み込み成功")
        $('.sticky-add-success').addClass('add_now');
        setTimeout(function () {
          $('.sticky-add-success').removeClass('add_now');
        }, 2000);
        setTimeout(getCartCount, 100);
      },
      error: function () {
        console.log("add.js 読み込み失敗")
      }
    });
  }

  function getCartCount() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json'
    })
      .then(
        // 通信成功時

        function (cart) {
          let nowCount = cart.item_count;
          $('.bubble-count').text(nowCount);
          console.log("cart.js 読み込み成功");
        },
        // 通信失敗時
        function () {
          console.log("cart.js 読み込み失敗");
        }
      );
  }

  let countGetter = 1;
  let countSetter = 1;
  let maxCount = $('.incoco-sticky-cart__btn').data('count');

  $(".incoco-sticky-cart--up").on('click', function () {
    countGetter = $(".incoco-sticky-cart__input").val();
    if (countGetter < maxCount) {
      countSetter = ++countGetter;
      $(".incoco-sticky-cart__input").val(countSetter);
    }
  });

  $(".incoco-sticky-cart--down").on('click', function () {
    countGetter = $(".incoco-sticky-cart__input").val();
    if (countGetter > 1) {
      countSetter = --countGetter;
      $(".incoco-sticky-cart__input").val(countSetter);
    }

  });

  // 価格のフォント変化
  $('.boost-pfs-filter-product-item-price').addClass('jost');

  $(".boost-pfs-filter-product-item-image").addClass('grid-collection-name');

  // 貼り方ページのタブ
  $(function() {
    $('.incoco-how-tab-menu__tab').on('click', function() {
      $('.incoco-how-tab-menu__tab, .incoco-how-tab-contents').removeClass('active');

      $(this).addClass('active');

      var index = $('.incoco-how-tab-menu__tab').index(this);
      $('.incoco-how-tab-contents').eq(index).addClass('active');
    });
  });
});
